import React from 'react';
import DataTable from '../../../widgets/data-table/DataTable/DataTable';
import PropTypes from 'prop-types';
import './InactiveBranchesPage.css';
import { injectIntl } from 'react-intl';
import { intlText } from '../../../../utils/text-util';

const InactiveBranchesPage = (props) => {
  const columns = [
    {
      header: {
        display: intlText(props, 'branch_code')
      },
      accessor: (branch) => ({
        display: branch.branchName
      })
    },
    {
      header: {
        display: intlText(props, 'branch_description')
      },
      accessor: (branch) => ({
        display: branch.branchDesc
      })
    }
  ];

  return (
    <div>
      <div className="row">
        {/* All inactive branches table */}
        <div className="col-xs-12 col-md-4 col-md-offset-1 selectable">
          <h3>{intlText(props, 'inactive_branches')}</h3>
          <DataTable columns={columns} bodyData={props.inactiveBranches} />
        </div>
      </div>
    </div>
  );
};

InactiveBranchesPage.propTypes = {
  inactiveBranches: PropTypes.arrayOf(PropTypes.object.isRequired)
};

export default injectIntl(InactiveBranchesPage);
